import React from 'react';
import styled from 'styled-components/macro';
import { Flex } from 'lib/components/styles/layout';

interface StyleObject {
  container?: React.CSSProperties;
  wrapper?: React.CSSProperties;
}

interface IFormSectionProps {
  title: string;
  children: JSX.Element | JSX.Element[];
  extendStyles?: StyleObject;
}

export const SectionTitle = styled.div`
  text-transform: uppercase;
  color: ${props => props.theme.colors.secondary[40]};
  font-size: 11px;
  font-weight: 700;
  display: flex;
  max-width: 287px;
  overflow: hidden;
  white-space: nowrap;

  &::after {
    height: 1px;
    width: 300px;
    display: block;
    background-color: ${props => props.theme.colors.secondary[5]};
    content: '';
    margin: 5px 0 0 12px;
  }
`;

export const FormSection = ({
  title,
  children,
  extendStyles,
}: IFormSectionProps) => {
  return (
    <Flex gap='16px' style={extendStyles?.wrapper}>
      <SectionTitle style={extendStyles?.container}>{title}</SectionTitle>
      {children}
    </Flex>
  );
};
